import { connectorFactory } from 'components/app/connectorFactory'
import { CONSTS } from 'config/objectConst'

const appConnector = connectorFactory(CONSTS.EXTENSION_ID, CONSTS.BACKUP_EXTENSION_ID)

export { appConnector }
